import {
  CButton,
  CCol,
  CFormInput,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow
} from '@coreui/react';
import React, { useContext } from 'react';
import { AppContext } from '../../context/AppContext';
import styles from './Table.module.css';
import TableCaption from './TableCaption';
import TableFooter from './TableFooter';



// Valores vacíos se muestran con un guión tenue en vez de una celda en blanco
const cell = (value) =>
  value === null || value === undefined || value === '' ? (
    <span className={styles.cellEmpty}>—</span>
  ) : (
    value
  );

const Table = ({ columns, data, pagination }) => {

  const {setUsersPageUrl} = useContext(AppContext);

  return (
    <>
      {/* <CCol xs={12} className="mt-4 mb-5">
        <CFormInput
          type="search"
          placeholder="Buscar por nombre de usuario"
          // onChange={handleFilter}
          style={{ width: '100%' }}
        />
      </CCol> */}

        <div className="col-12">
        <TableCaption pagination={pagination} noun="usuarios" />
        <div className={styles.tableCard}>
          <CTable responsive align="middle" className={styles.styledTable}>
            <CTableHead>
              <CTableRow>
                {columns.map((col, index) => (
                  <CTableHeaderCell key={index} scope="col">
                    {col.label}
                  </CTableHeaderCell>
                ))}
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {data.map((el, index) => (
                <CTableRow key={index}>
                  <CTableDataCell className={styles.cellId}>{el.id}</CTableDataCell>
                  <CTableDataCell>
                    <span className={styles.userName}>{el.name}</span>
                  </CTableDataCell>
                  <CTableDataCell>{cell(el.email)}</CTableDataCell>
                  <CTableDataCell>{cell(el.phone_country_code)}</CTableDataCell>
                  <CTableDataCell>{cell(el.phone_area_code)}</CTableDataCell>
                  <CTableDataCell>{cell(!el?.phone_country_code ? el?.phone : el?.phone_number)}</CTableDataCell>
                  <CTableDataCell>{cell(el?.address?.address)}</CTableDataCell>
                  <CTableDataCell>{cell(el?.address?.zip_code)}</CTableDataCell>
                </CTableRow>
              ))}
            </CTableBody>
          </CTable>
          {data.length === 0 && (
            <div className={styles.emptyState}>No se encontraron resultados.</div>
          )}
        </div>
        </div>
        <TableFooter range={pagination?.links} setPageUrl={setUsersPageUrl} />
    </>
  );
};

export default Table;
